import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Button, Box, Typography } from "@mui/material";

import { ThemeContext } from "../../context/ThemeContext";

import { ModeChangebar } from "./ModeChangebar";

import { ReactComponent as User } from "../../assets/topbar/user.svg";

import { getColors } from "../../themes/theme";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";

export const ProfileTopbar = () => {
  const { user } = useAuthContext();
  const isUser = user?.securityType === 3;
  const { darkMode } = useContext(ThemeContext);
  const navigate = useNavigate();

  const handleUsersClick = () => {
    navigate("/users");
  };

  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: 0,
        py: { xs: 2, md: 4 },
        px: { xs: 1, md: 2 },
      }}
    >
      <Toolbar
        display="flex"
        sx={{ alignItems: "center", ml: { xs: "auto", sm: 0 } }}
      >
        <Box
          display={{ xs: "none", sm: "flex" }}
          sx={{
            alignItems: "center",
            flexGrow: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 500,
              fontFamily: "Poppins",
              color: darkMode
                ? getColors.thumbnailTextDark
                : getColors.thumbnailTextLight,
            }}
          >
            My Profile
          </Typography>
          {!isUser && (
            <Button
              onClick={handleUsersClick}
              variant="contained"
              startIcon={<User />}
              sx={{
                fontSize: "17px",
                px: 3,
                py: "14px",
                borderRadius: "100px",
                mr: { xs: 2, sm: "60px" },
              }}
            >
              Users
            </Button>
          )}
        </Box>
        <ModeChangebar visibleViewMode={false} />
      </Toolbar>
    </AppBar>
  );
};
